/**
 * @generated SignedSource<<e3a995b867ea450673250768f9e348ed>>
 * @relayHash ef1111bd15d10eaaab0f3bd5698ebf18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 12af83d9dec697d2b286a6fc415281377a8f74d26d8aff5a0c9d7d5938b7d228

import type { ConcreteRequest } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type editionBenefitsModalRelayQuery$variables = {
  cloudId: string;
  hamsProductKey: string;
  projectType: JiraProjectType;
};
export type editionBenefitsModalRelayQuery$data = {
  readonly jira: {
    readonly allJiraProjects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly assignableUsers: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly accountId: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly key: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly tenantContexts: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null | undefined;
    } | null | undefined;
    readonly cloudUrl: AGG$URL | null | undefined;
    readonly entitlementInfo: {
      readonly entitlement?: {
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
          readonly changeToStandard: {
            readonly experienceUrl: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly entitlement: {
            readonly subscription: {
              readonly accountDetails: {
                readonly invoiceGroup: {
                  readonly experienceCapabilities: {
                    readonly configurePaymentV2: {
                      readonly experienceUrl: string | null | undefined;
                    } | null | undefined;
                  } | null | undefined;
                  readonly invoiceable: boolean | null | undefined;
                } | null | undefined;
              } | null | undefined;
              readonly billingPeriodDetails: {
                readonly nextBillingTimestamp: number | null | undefined;
              } | null | undefined;
            } | null | undefined;
            readonly transactionAccount: {
              readonly experienceCapabilities: {
                readonly addPaymentMethodV2: {
                  readonly experienceUrl: string | null | undefined;
                } | null | undefined;
              } | null | undefined;
              readonly isBillToPresent: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly relationshipType: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly subscription: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities: {
                readonly configurePaymentV2: {
                  readonly experienceUrl: string | null | undefined;
                } | null | undefined;
              } | null | undefined;
              readonly invoiceable: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly billingPeriodDetails: {
            readonly nextBillingTimestamp: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly transactionAccount: {
          readonly experienceCapabilities: {
            readonly addPaymentMethodV2: {
              readonly experienceUrl: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly isBillToPresent: boolean | null | undefined;
          readonly isCurrentUserBillingAdmin: boolean | null | undefined;
          readonly key: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly entitlementId: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type editionBenefitsModalRelayQuery = {
  response: editionBenefitsModalRelayQuery$data;
  variables: editionBenefitsModalRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hamsProductKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectType"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "cloudUrl"
},
v3 = {
  "args": [
    {
      "kind": "Literal",
      "name": "product",
      "value": "jira"
    }
  ],
  "concreteType": "TenantContextActivationId",
  "kind": "LinkedField",
  "name": "activationIdByProduct",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "active"
    }
  ],
  "storageKey": "activationIdByProduct(product:\"jira\")"
},
v4 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v6 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "offeringName",
          "value": "Premium"
        }
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isAvailableToUser"
        }
      ],
      "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
    },
    {
      "alias": "changeToStandard",
      "args": [
        {
          "kind": "Literal",
          "name": "offeringName",
          "value": "Standard"
        }
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
    }
  ]
},
v9 = [
  {
    "kind": "Literal",
    "name": "relationshipTypes",
    "value": "COLLECTION"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "relationshipType"
},
v11 = {
  "concreteType": "CcpBillingPeriodDetails",
  "kind": "LinkedField",
  "name": "billingPeriodDetails",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "nextBillingTimestamp"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v13 = {
  "concreteType": "CcpInvoiceGroupExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
      "kind": "LinkedField",
      "name": "configurePaymentV2",
      "plural": false,
      "selections": (v7/*: any*/)
    }
  ]
},
v14 = {
  "concreteType": "CcpSubscription",
  "kind": "LinkedField",
  "name": "subscription",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "concreteType": "CcpAccountDetails",
      "kind": "LinkedField",
      "name": "accountDetails",
      "plural": false,
      "selections": [
        {
          "concreteType": "CcpInvoiceGroup",
          "kind": "LinkedField",
          "name": "invoiceGroup",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/)
          ]
        }
      ]
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "isBillToPresent"
},
v16 = {
  "concreteType": "CcpTransactionAccountExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpAddPaymentMethodExperienceCapability",
      "kind": "LinkedField",
      "name": "addPaymentMethodV2",
      "plural": false,
      "selections": (v7/*: any*/)
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "key"
},
v18 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v19 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "types.0",
            "variableName": "projectType"
          }
        ],
        "kind": "ListValue",
        "name": "types"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v20 = {
  "kind": "ScalarField",
  "name": "id"
},
v21 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v22 = {
  "kind": "ScalarField",
  "name": "name"
},
v23 = {
  "kind": "ScalarField",
  "name": "picture"
},
v24 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v25 = {
  "concreteType": "CcpSubscription",
  "kind": "LinkedField",
  "name": "subscription",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "concreteType": "CcpAccountDetails",
      "kind": "LinkedField",
      "name": "accountDetails",
      "plural": false,
      "selections": [
        {
          "concreteType": "CcpInvoiceGroup",
          "kind": "LinkedField",
          "name": "invoiceGroup",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/),
            (v20/*: any*/)
          ]
        }
      ]
    },
    (v20/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "editionBenefitsModalRelayQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "args": (v9/*: any*/),
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlement",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "concreteType": "CcpTransactionAccount",
                                "kind": "LinkedField",
                                "name": "transactionAccount",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v16/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                      },
                      (v14/*: any*/),
                      {
                        "concreteType": "CcpTransactionAccount",
                        "kind": "LinkedField",
                        "name": "transactionAccount",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v15/*: any*/),
                          (v18/*: any*/),
                          (v16/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v19/*: any*/),
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "allJiraProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v17/*: any*/),
                      {
                        "concreteType": "JiraAssignableUsersConnection",
                        "kind": "LinkedField",
                        "name": "assignableUsers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraAssignableUsersEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "editionBenefitsModalRelayQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "args": (v9/*: any*/),
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlement",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "concreteType": "CcpTransactionAccount",
                                "kind": "LinkedField",
                                "name": "transactionAccount",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v20/*: any*/)
                                ]
                              },
                              (v20/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                      },
                      (v25/*: any*/),
                      {
                        "concreteType": "CcpTransactionAccount",
                        "kind": "LinkedField",
                        "name": "transactionAccount",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v15/*: any*/),
                          (v18/*: any*/),
                          (v16/*: any*/),
                          (v20/*: any*/)
                        ]
                      },
                      (v20/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v19/*: any*/),
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "allJiraProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v17/*: any*/),
                      {
                        "concreteType": "JiraAssignableUsersConnection",
                        "kind": "LinkedField",
                        "name": "assignableUsers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraAssignableUsersEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v20/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "12af83d9dec697d2b286a6fc415281377a8f74d26d8aff5a0c9d7d5938b7d228",
    "metadata": {},
    "name": "editionBenefitsModalRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4adcf3c0d1fd080dc809373daae7326c";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
